<div class="table-list-thumbnail" [ngClass]="{'rounded-circle':rounded}" [ngStyle]="{
	'background-image':
	'url(' +
	(source) +
	')'
}"></div>